module.exports = __webpack_public_path__ + "img/uke-chord.101cb4a4.jpg";